// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "18906444ea5cb0cdfeb16400a39a1f7d" + ".js";
};